// MEO landmark ads (Phase 1, Step 4-3): landmarks CRUD endpoints の HTTP クライアント。
// api 側 implementation: omikuji-api Step 3-4 (PR #45) で landmarks CRUD を提供。
//
// auth: ADMIN (全件) / BUSINESS (自分が sponsor の landmark のみ)。
// CMS 側はログイン user の role_id に応じて backend が自動フィルタ。

import ApiService from './ApiService';

export default class LandmarkApi extends ApiService {
    // GET /system/landmarks?category=&page=&limit=
    list(payload?: any) {
        return this.get('landmarks', payload);
    }

    getById(id: string | number) {
        return this.get(`landmarks/${id}`);
    }

    create(payload: any) {
        return this.post('landmarks', payload);
    }

    update(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`landmarks/${id}`, data);
    }

    remove(id: string | number) {
        return this.delete(`landmarks/${id}`);
    }

    // MEO Phase 1 Sprint 2-F (2026-05-13):
    // landmark.metadata.review_bonus_strategy を部分更新する dedicated endpoint。
    // body: { mode, rate_upgrade?, public_spots_unlock?, digital_unlock?, bonus_duration_minutes? }
    updateReviewBonusStrategy(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`landmarks/${id}/review-bonus-strategy`, data);
    }
}
